import React from 'react';
import { useSelector } from 'react-redux';

import { Bolt } from '@helpers/icon-dictionary';
import useContextModal from '@helpers/hooks/use-context-modal';
import OutsideClickHandler from '@helpers/hoc/close/outside-click-handler';

import SvgIcon from '@components/svg-icon/svg-icon';
import ContextModal from '@components/context-modal';
import { PROGRESS } from '@components/accuracy-progress-toggle/accuracy-progress-constants';

import ProgressModalContent from './progress-modal-content';
import AccuracyModalContent from './accuracy-modal-content';

import { Root, ToggleButton } from './styled';

const QuickSelector = () => {
  /**
   * Store
   */
  const currentSelectedFilter = useSelector(state => state.UPFAssignReducer.accuracyProgressToggle.currentFilter);

  /**
   * Hooks
   */
  const { showContextModal, contentModalProps, closeContextMenu, targetRef } = useContextModal();

  /**
   * Local variables
   */
  const isProgressFilterSelected = currentSelectedFilter === PROGRESS;

  return (
    <Root>
      <ToggleButton data-testid="toggle-quick-selector" ref={targetRef} onClick={showContextModal}>
        <SvgIcon icon={Bolt} />
      </ToggleButton>
      <OutsideClickHandler callback={closeContextMenu} forButton="quickSelector">
        <ContextModal {...contentModalProps}>
          {isProgressFilterSelected ? (
            <ProgressModalContent closeContextMenu={closeContextMenu} />
          ) : (
            <AccuracyModalContent closeContextMenu={closeContextMenu} />
          )}
        </ContextModal>
      </OutsideClickHandler>
    </Root>
  );
};

export default QuickSelector;
